import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { IS_DEV } from '../../config';
import { storage } from '../utils/storage';

export const useSaveSessionData = () => {
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');
  const vendorProductId = searchParams.get('vendorProductId');
  const embedScriptInjected = searchParams.get('embedScriptInjected');
  const shouldSaveToken = searchParams.get('shouldSaveToken');

  useEffect(() => {
    if (IS_DEV && shouldSaveToken) {
      token && storage.setItem('wixDevAccessToken', token);
      vendorProductId && storage.setItem('userPlan', vendorProductId);
      embedScriptInjected && storage.setItem('embedScriptInjected', embedScriptInjected);
    }
  }, [shouldSaveToken, token, vendorProductId, embedScriptInjected]);
};
